/* pdp-external.js — calls your Worker and appends unique links.
   - Always runs discovery (even when metafields already have values)
   - Appends only new/unique URLs to the list
   - If "Write to metafields" is enabled, sends only new URLs
*/
(function () {
  if (window.__PDP_EXT_LOADED__) return;
  window.__PDP_EXT_LOADED__ = true;

  const WORKER_DEFAULT = "https://pdp-ext.phalecia.workers.dev/"; // your worker
  const inEditor = !!(window.Shopify && window.Shopify.designMode);

  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function jsonFetch(url, init) {
  return fetch(url, Object.assign({ mode: "cors", credentials: "omit" }, init))
    .then((r) => {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
}


  function normalize(href) {
    try {
      const u = new URL(href);
      u.hash = "";
      ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","fbclid","gclid","igshid"].forEach(p => u.searchParams.delete(p));
      u.pathname = u.pathname.replace(/\/+$/,"") || "/";
      u.hostname = u.hostname.toLowerCase();
      return u.toString();
    } catch { return href; }
  }

  function existingSetFromList(root) {
    const list = root.querySelector(".pdp-ext__list");
    const set = new Set();
    $all("a[href]", list).forEach(a => set.add(normalize(a.href)));
    return set;
  }

  function buildQuery(kind, title, vendor, override) {
    if (override && override !== "AUTO") return override;
    const parts = [`"${title}"`];
    if (vendor) parts.push(`"${vendor}"`);
    parts.push("board game");
    if (kind === "videos") parts.push("review OR playthrough OR unboxing");
    if (kind === "articles") parts.push("review OR thread");
    if (kind === "podcasts") parts.push("podcast OR interview");
    return parts.join(" ");
  }

  function appendItems(root, items) {
    const list = root.querySelector(".pdp-ext__list");
    const existing = root.__existing || existingSetFromList(root);
    root.__existing = existing;

    let appended = 0;
    (items || []).forEach((it) => {
      const href = normalize(it.url);
      if (existing.has(href)) return; // skip dups
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = href;
      a.target = "_blank";
      a.rel = "noopener";
      a.textContent = it.title || href;
      li.appendChild(a);
      list.appendChild(li);
      existing.add(href);
      appended++;
    });

    if ((root.__existing && root.__existing.size > 0)) {
      root.classList.remove("pdp-ext--empty");
    } else {
      root.classList.add("pdp-ext--empty");
    }
    return appended;
  }

  async function discover(root) {
    const kind = root.dataset.kind;
    const worker = root.dataset.worker || WORKER_DEFAULT;
    const title = root.dataset.title || "";
    const vendor = root.dataset.vendor || "";
    const override = root.dataset.qoverride || "AUTO";
    const allowlist = (root.dataset.allowlist || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const q = buildQuery(kind, title, vendor, override);
    const u = new URL("/discover", worker);
    u.searchParams.set("kind", kind);
    u.searchParams.set("q", q);
    u.searchParams.set("limit", root.dataset.limit || "10");

    const res = await jsonFetch(u.toString());
    let items = res.items || [];

    if (allowlist.length) {
      items = items.filter((it) => {
        try {
          const h = new URL(it.url).hostname;
          return allowlist.some((d) => h.includes(d));
        } catch { return false; }
      });
    }

    root.__discovered = items;
    const appended = appendItems(root, items);
    return { items, appended };
  }

  async function saveToMetafields(root) {
    const worker = root.dataset.worker || WORKER_DEFAULT;
    const discovered = root.__discovered || [];
    if (!discovered.length) return;

    const existing = root.__existing || existingSetFromList(root);
    const newUrls = discovered
      .map(x => normalize(x.url))
      .filter(u => !existing || !existing.has(u)); // only new vs render-time existing
    if (!newUrls.length) return;

    const u = new URL("/save", worker);
    const body = {
      productId: root.dataset.pid,
      kind: root.dataset.kind,
      urls: newUrls,
      editor: inEditor ? "1" : "0",
    };
    const r = await fetch(u.toString(), {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      console.warn("[pdp-ext] save failed:", r.status);
    }
  }

  function initOne(root) {
    const doDiscover = root.dataset.discover === "true";
    const doWrite = root.dataset.write === "true";
    if (doDiscover) {
      discover(root)
        .then(() => { if (doWrite) return saveToMetafields(root); })
        .catch((e) => console.warn("[pdp-ext] discover error:", e));
    }
  }

  document.addEventListener("shopify:section:load", (ev) => {
    const el = ev.target.querySelector(".pdp-ext");
    if (el) initOne(el);
  });

  document.addEventListener("DOMContentLoaded", () => {
    $all(".pdp-ext").forEach(initOne);
  });
})();
